var common = {
  downloadFile(
    fileData,
    contentType,
    fileName,
    forceDownload,
    sameTab = false
  ) {
    let reportName = fileName
    if (contentType === null || contentType === '') {
      contentType = 'pdf'
    }
    let blob = null
    if (fileData && fileData.isPlainString) {
      blob = new Blob([fileData.data], { type: contentType })
    } else {
      blob = new Blob([base64ToArrayBuffer(fileData)], {
        type: contentType,
      })
    }
    var url = window.URL.createObjectURL(blob)

    if (forceDownload) {
      // check for support for IE, which will not support blob save via links
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName)
      } else if (sameTab) {
        let link = document.createElement('a')
        link.href = url
        link.download = `${fileName}.${contentType}`
        link.click()
      } else {
        let link = document.createElement('a')
        link.href = url
        link.target = '_blank'
        link.download = fileName
        link.click()
      }

      return
    }

    if (contentType !== 'application/pdf') {
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, reportName)
      } else {
        let link = document.createElement('a')
        link.href = url
        link.click()
      }
    } else {
      return url
    }
  },

  generateFileUrl(fileData, contentType) {
    let blob = new Blob([base64ToArrayBuffer(fileData)], {
      type: contentType,
    })
    var url = window.URL.createObjectURL(blob)

    return url
  },

  displayModelErrors(errorResponse) {
    var errorsMessage = ''

    if (errorResponse.status === 400) {
      if (errorResponse.data.errors) {
        for (var key in errorResponse.data.errors) {
          errorsMessage =
            (errorsMessage === '' ? '' : errorsMessage + '\n') +
            errorResponse.data.errors[key]
        }
      } else {
        errorsMessage = errorResponse.data
      }
    }

    return errorsMessage
  },
  getDatepart(inputDate) {
    let dateTime = new Date(inputDate)
    let month = dateTime.getMonth() + 1
    let date = dateTime.getDate()
    month = String(month <= 9 ? '0' + month : month)
    date = String(date <= 9 ? '0' + date : date)
    return month + date
  },
  fixUnicodeCharsCsv(data) {
    return data
      .replaceAll('\u2014', '-')
      .replaceAll('\u2013', '-')
      .replaceAll('\u02E3', 'x')
  },
}
export default common

function base64ToArrayBuffer(base64) {
  var binaryString = window.atob(base64)
  var binaryLen = binaryString.length
  var bytes = new Uint8Array(binaryLen)
  for (var i = 0; i < binaryLen; i++) {
    var ascii = binaryString.charCodeAt(i)
    bytes[i] = ascii
  }
  return bytes
}
